<template>
    <template v-for="icon in icons">
        <img
            v-if="state === icon.status && icon.icon?.fullpath"
            :key="icon.id"
            :src="apiUrl + icon.icon.fullpath"
            width="auto"
            height="100%"
        />
    </template>
</template>

<script setup>
import { defineProps } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL

defineProps({
    state: String,
    icons: Array,
})
</script>
